import React, { useState } from 'react'
import { AddDeals } from './AddDeals'
import { AmzDealsTable } from './AmzDealsTable'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'

const AmazonDeals = () => {
  const [isAltered, setIsAltered] = useState(false)

  const handleAlterCallBack = () => {
    setIsAltered((prevstate) => !prevstate)
  }

  return (
    <AppShell>
      <PageHeader
        kicker="Pricing"
        title="Amazon Deals"
        subtitle="Manage deal submissions for Amazon promotions."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Pricing', to: '/pricing-tools' },
          { label: 'Amazon Deals' },
        ]}
        status={<span className="nx-chip-warn">In development</span>}
        actions={<AddDeals handleAlterCallBack={handleAlterCallBack} />}
      />
      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <AmzDealsTable isAltered={isAltered} />
      </div>
    </AppShell>
  )
}

export default AmazonDeals
